import * as React from 'react'
import { logRefTag } from '../../utils/url'

export interface IRecordRefTagProps {
  refTag?: string
  children?: JSX.Element
  className?: string
}

export const RecordRefTag = ({
  refTag,
  children,
  className = ''
}: IRecordRefTagProps) =>
  !refTag ? (
    <>children</>
  ) : (
    <span
      className={className}
      onClick={() => logRefTag(refTag)}>
      {children}
    </span>
  )
